exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ArrowButtons-module__arrow-buttons___3VpdY{display:grid;grid-auto-flow:column;width:-moz-fit-content;width:fit-content;gap:1rem}.ArrowButtons-module__arrow-buttons___3VpdY svg{font-size:13px}", ""]);

// exports
exports.locals = {
	"arrow-buttons": "ArrowButtons-module__arrow-buttons___3VpdY"
};